export default __webpack_public_path__ + "images/23d3639ee26147811c83de8285193a57.svg";